import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class UserService {
    updatePassword(data) {
        return axios.post(Config.apiBasePath + '/user/update/password', data,{ headers: authHeader() });
    }

    async getAllDeletedUsers(){
        const response = await axios.get(Config.apiBasePath + '/getAllUsersInactiveUsers', { headers: authHeader() });
        return response;
    }

    async getAllUsers(){
        const response = await axios.get(Config.apiBasePath + '/getUser', { headers: authHeader() });
        return response;
    }

    async getUserById(){
        const response = await axios.get(Config.apiBasePath + '/getLoggedInUser', { headers: authHeader() });
        return response.data;
    }

    resetPassword(data){
        return axios.post(Config.apiBasePath + '/resetPasswordByUser', data,{ headers: authHeader() });
    }


    async userHardDelete(data) {
        const response = await axios.delete(Config.apiBasePath + '/hardDeleteUser/' + data, { headers: authHeader() });
        return response;
    }
    async userRevert(data) {
        const response = await axios.get(Config.apiBasePath + '/revertUser/' + data, { headers: authHeader() });
        return response;
    }
}

export default new UserService();
